document.addEventListener('DOMContentLoaded', () => {
  const footerMask = document.querySelector('.footer-video-mask');
  if (!footerMask) return;

  const videoContainer = footerMask.querySelector('.footer-video-container');
  const footer        = document.getElementById('site-footer');

  const videoId       = footer.dataset.videoBg;
  if (!videoId) return;

  // funkcija za učitavanje iframe-a
  const loadFooterVideo = () => {
    if (videoContainer.dataset.loaded === 'true') return;
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&controls=0&modestbranding=1&rel=0&loop=1&playlist=${videoId}`;
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'autoplay; fullscreen');
    iframe.setAttribute('loading', 'lazy');
    videoContainer.appendChild(iframe);
    videoContainer.dataset.loaded = 'true';
  };

  // IntersectionObserver za footer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        loadFooterVideo();
        observer.disconnect();
      }
    });
  }, { threshold: 0.3 });

  observer.observe(footerMask);
});

// // Mobile navigation toggle button function
// $(".header .navbar-toggler").on("click", function () {
//   if ($("body").hasClass("mobile-nav-open")) {
//     // hide mobile nav
//     $(".site-navigation").toggleClass("site-navigation-open");
//     $("body").toggleClass("mobile-nav-open");
//     $(".header").toggleClass("mobile-nav-open");
    
//     setTimeout(function() {
//       $("header").toggleClass("mobile-nav-open-z-index");
//     }, 360); // sum of transition duration and a bit more for class removing proccessing
//   } else {
//     // display mobile nav
//     $("header").toggleClass("mobile-nav-open-z-index");

//     setTimeout(function() {
//       $(".site-navigation").toggleClass("site-navigation-open");
//       $("body").toggleClass("mobile-nav-open");
//       $(".header").toggleClass("mobile-nav-open");
//     }, 60);
//   }
// });

// // Adding class on scroll for colored header
// var heroHeight = 70;
// // if ($(".daynightmedia-section.homepage-hero").length) {
// //   heroHeight = $(".daynightmedia-section.homepage-hero").height();
// //   heroHeight = heroHeight / 2;
// // }
// function daynightmedia_header_classes_on_load_and_scroll() {
//   if ($('header').hasClass('transparent-header')) {
//     var scroll = $(window).scrollTop();
//     if (scroll >= heroHeight) {
//       $(".header").addClass("header-scrolled");
//       $('.header .navbar-btn-wrap .btn.d-llg-flex').removeClass('btn-light');
//     } else {
//       $(".header").removeClass("header-scrolled");
//       $('.header .navbar-btn-wrap .btn.d-llg-flex').addClass('btn-light');
//     }
//   }
// }

// $(window).on("scroll", function () {
//   if ($('header').hasClass('transparent-header')) {
//     daynightmedia_header_classes_on_load_and_scroll();
//   }
// });
// $(window).on("load", function() {
//   setTimeout(() => {
//     daynightmedia_header_classes_on_load_and_scroll();
//   }, 500);
// });

document.addEventListener('DOMContentLoaded', function () {
  const navbarToggler = document.querySelector('.header .navbar-toggler');
  const body = document.body;
  const header = document.querySelector('.header');
  const siteNav = document.querySelector('.site-navigation');

  if (navbarToggler && header && siteNav) {
    navbarToggler.addEventListener('click', function () {
      if (body.classList.contains('mobile-nav-open')) {
        siteNav.classList.toggle('site-navigation-open');
        body.classList.toggle('mobile-nav-open');
        header.classList.toggle('mobile-nav-open');
        setTimeout(function () {
          document.querySelector('header')?.classList.toggle('mobile-nav-open-z-index');
        }, 360);
      } else {
        document.querySelector('header')?.classList.toggle('mobile-nav-open-z-index');
        setTimeout(function () {
          siteNav.classList.toggle('site-navigation-open');
          body.classList.toggle('mobile-nav-open');
          header.classList.toggle('mobile-nav-open');
        }, 60);
      }
    });
  }

  const heroHeight = 70;
  const mainHeader = document.querySelector('header');
  const scrollBtn = document.querySelector('.header .navbar-btn-wrap .btn.d-llg-flex');

  function daynightmedia_header_classes_on_load_and_scroll() {
    if (mainHeader && mainHeader.classList.contains('transparent-header')) {
      const scroll = window.scrollY;
      if (scroll >= heroHeight) {
        mainHeader.classList.add('header-scrolled');
        // scrollBtn?.classList.remove('btn-light');
      } else {
        mainHeader.classList.remove('header-scrolled');
        // scrollBtn?.classList.add('btn-light');
      }
    }
  }

  window.addEventListener('scroll', daynightmedia_header_classes_on_load_and_scroll);

  window.addEventListener('load', function () {
    setTimeout(daynightmedia_header_classes_on_load_and_scroll, 500);
  });
});

// $.fn.isInViewport = function () {
//     let elementTop = $(this).offset().top;
//     let elementBottom = elementTop + $(this).outerHeight();
//     let viewportTop = $(window).scrollTop();
//     let viewportBottom = viewportTop + $(window).height();
//     return elementBottom > viewportTop && elementTop < viewportBottom;
// };

// $(window).on("load resize scroll", function () {
//     $('.animateOnEnter').each(function() {
//         if ( $(this).isInViewport() ) {
//             $(this).addClass('inView');
//         }
//     });
// });
document.addEventListener("DOMContentLoaded", () => {
  const elems = document.querySelectorAll('.animate-on-scroll');
  if (!('IntersectionObserver' in window)) {
    // fallback: prikaži odmah
    elems.forEach(el => el.classList.add('in-view'));
    return;
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting) {
        target.classList.add('in-view');
        io.unobserve(target);  // animiraj samo jednom
      }
    });
  }, {
    rootMargin: '0px 0px -15% 0px', // pokreće malo ranije
    threshold: 0
  });

  elems.forEach(el => io.observe(el));
});

document.addEventListener('DOMContentLoaded', function() {
	function checkScrollAndAnimate() {
		if (window.scrollY >= 300) {
			var el = document.getElementById('daynightmedia-lens-graphic');
			if (el && !el.classList.contains('animated-in')) {
				el.classList.add('animated-in');
			}
			window.removeEventListener('scroll', checkScrollAndAnimate);
		}
	}

	window.addEventListener('scroll', checkScrollAndAnimate);
	// In case the user is already scrolled past 300px on load
	checkScrollAndAnimate();
});

const sections = document.querySelectorAll('.daynightmedia-section');
const titleEl = document.querySelector('#daynightmedia-lens-graphic--content__title');
const numEl = document.querySelector('#daynightmedia-lens-graphic--content__num');
const lensImg = document.querySelector('#daynightmedia-lens-graphic img');

const maxRotation = 70;
const totalSections = sections.length;

let activeIndex = -1;
// let typingTimeout;

function getVisibleSectionIndex() {
	const scrollY = window.scrollY;
	const viewportHeight = window.innerHeight;

	let closest = -1;
	let closestDistance = Infinity;

	sections.forEach((section, index) => {
		const rect = section.getBoundingClientRect();
		const offset = Math.abs(rect.top - viewportHeight * 0.3); // promjena
		if (offset < closestDistance) {
			closestDistance = offset;
			closest = index;
		}
	});

	return closest;
}

function typeWriter(element, newText) {
	let eraseSpeed = Math.max(15, 60 - newText.length); // adaptivno, brže za dulje riječi
	let typeSpeed = 50;
	let eraseIndex = element.textContent.length;
	let typeIndex = 0;

	function erase() {
		if (eraseIndex > 0) {
			element.textContent = element.textContent.slice(0, --eraseIndex);
			setTimeout(erase, eraseSpeed);
		} else {
			setTimeout(type, 100);
		}
	}

	function type() {
		if (typeIndex < newText.length) {
			element.textContent += newText.charAt(typeIndex++);
			setTimeout(type, typeSpeed);
		}
	}

	erase();
}

function typeWriterNum(element, newText) {
	let eraseIndex = element.textContent.length;
	let typeIndex = 0;

	function erase() {
		if (eraseIndex > 0) {
			element.textContent = element.textContent.slice(0, --eraseIndex);
			setTimeout(erase, 20);
		} else {
			setTimeout(type, 50);
		}
	}

	function type() {
		if (typeIndex < newText.length) {
			element.textContent += newText.charAt(typeIndex++);
			setTimeout(type, 40);
		}
	}

	erase();
}

function updateGraphic(index) {
	if (index === activeIndex || index < 0 || index >= sections.length) return;
	activeIndex = index;

	const title = sections[index].dataset.graphicTitle || '';
	const number = `#${index + 1}`;

	typeWriter(titleEl, title);
	typeWriterNum(numEl, `${index + 1}`);

	const step = maxRotation / (totalSections - 1 || 1);
	const rotateDeg = Math.round(step * index);

	lensImg.style.transform = `rotate(${rotateDeg}deg)`;
}

// Debounce scroll
let scrollTimeout;
window.addEventListener('scroll', () => {
	const lensGraphicEl = document.getElementById('daynightmedia-lens-graphic');
	if (lensGraphicEl) {
		if (scrollTimeout) clearTimeout(scrollTimeout);
		scrollTimeout = setTimeout(() => {
			const index = getVisibleSectionIndex();
			updateGraphic(index);
		}, 100);
	}
});

document.addEventListener("DOMContentLoaded", function () {
	var modal = document.getElementById("dnm-booking-modal");
	if (modal) {
		var closeBtn = modal.querySelector(".dnm-modal__close");
		var actionBtn = modal.querySelector(".dnm-modal__action");
		var shownKey = "dnm_modal_shown";
		var scrollFired = false;

		// Prikaži modal
		function showModal() {
			modal.classList.remove("dnm-modal--hidden");
			modal.classList.add("dnm-modal--visible");
		}

		// Sakrij modal i zabilježi da je prikazan
		function hideModal() {
			modal.classList.remove("dnm-modal--visible");
			modal.classList.add("dnm-modal--hidden");
			localStorage.setItem(shownKey, "yes");
		}

		// Provjera i prikaz nakon scrolla
		function onScroll() {
			if (scrollFired) return;
			if (window.scrollY >= 300 && !localStorage.getItem(shownKey)) {
				scrollFired = true;
				showModal();
				window.removeEventListener("scroll", onScroll);
			}
		}

		// Dodaj listener za scroll
		window.addEventListener("scroll", onScroll);

		// Event za zatvaranje
		closeBtn.addEventListener("click", hideModal);
		actionBtn.addEventListener("click", hideModal);
	}
});

// $('[data-toggle="scroll-to"]').click(function() {

//   var $this = $(this);

//   if ( $this.data('scroll-offset') == true ) {
//     var offset = $('.header').height();
//   } else {
//     var offset = 0;
//   }

//   if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
//     var target = $(this.hash);
//     target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
//     if (target.length) {
//       $('html, body').animate({
//         scrollTop: target.offset().top - offset
//       }, 1000);
//       return false;
//     }
//   }
// });
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-toggle="scroll-to"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      const useOffset = link.dataset.scrollOffset === 'true';
      const offset = useOffset ? ((document.querySelector('.header')?.offsetHeight || 0) + 30) : 30;

      const currentPath = location.pathname.replace(/^\//, '');
      const targetPath = link.pathname.replace(/^\//, '');
      const isSamePage = currentPath === targetPath && location.hostname === link.hostname;

      if (isSamePage) {
        let target = document.querySelector(link.hash);
        if (!target) {
          target = document.querySelector('[name="' + link.hash.slice(1) + '"]');
        }

        if (target) {
          const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({
            top: top,
            behavior: 'smooth'
          });
        }
      }
    });
  });
});

// $(document).ready(function() {
// 	$("#skipper").click(function() {
// 		$('#mainContent').attr('tabIndex', -1).focus();
// 	})
// });
document.addEventListener('DOMContentLoaded', function () {
  const skipper = document.getElementById('skipper');
  const mainContent = document.getElementById('mainContent');

  if (skipper && mainContent) {
    skipper.addEventListener('click', function () {
      mainContent.setAttribute('tabindex', '-1');
      mainContent.focus();
    });
  }
});

// $(document).ready(function() {
// 	var width   = 981;
// 	var height  = 461;
// 	var left    = (screen.width / 2) - (width / 2);
// 	var top     = (screen.height / 2) - (height / 2);
// 	$('.js-share-link').click(function(e) {
// 		e.preventDefault();
// 		window.open(
// 		$(this).attr('href'),
// 		'',
// 		'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=' + width + ',height=' + height + ',top=' + top + ',left=' + left
// 		);
// 	});
// });
document.addEventListener('DOMContentLoaded', function () {
  const width = 981;
  const height = 461;
  const left = (screen.width / 2) - (width / 2);
  const top = (screen.height / 2) - (height / 2);

  const shareLinks = document.querySelectorAll('.js-share-link');

  shareLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      window.open(
        link.getAttribute('href'),
        '',
        'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,' +
        'width=' + width + ',height=' + height +
        ',top=' + top + ',left=' + left
      );
    });
  });
});
